import { memo } from "react";
import styleSheet from "./style.module.scss";

export interface OrbSwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  label?: any;
  disabled?: boolean;
  className?: string;
  name?: string;
}

const OrbSwitch = ({
  value,
  onChange,
  label,
  disabled = false,
  className = "",
  name,
}: OrbSwitchProps) => {
  const toggle = () => {
    if (!disabled) onChange(!value);
  };

  return (
    <div className={`d-flex align-items-center gap-2 ${className}`}>
      <input
        type="checkbox"
        checked={value}
        name={name}
        readOnly
        hidden
      />

      <div
        role="switch"
        aria-checked={value}
        onClick={toggle}
        className={`${styleSheet.switch} ${
          value ? styleSheet.checked : ""
        } ${disabled ? styleSheet.disabled : ""}`}
      >
        <span className={styleSheet.thumb} />
      </div>

      {label && (
        <label
          className={`mohave text-white pointer ${
            disabled ? "opacity-50" : ""
          }`}
          onClick={toggle}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default memo(OrbSwitch);
